const onBoxEnd = ( ctx, event ) => {
    if ( !event.boxAnimation || event.boxAnimation !== true ) {
        return;
    }

    ctx.root.dispatchEvent( new CustomEvent( 'twc:mapsearch:bboxend', {
        bubbles: true,
        detail: event,
    } ) );
};

export default onBoxEnd;
